import api from '@/api';
import { RESTFUL } from '@/data/constants';

export async function getWhatsappConversations(params = {}) {
  const { data } = await api.get(RESTFUL.whatsappMessage.conversations, {
    params,
  });
  return data;
}

export async function getWhatsappMessagesByPhone(phone, params = {}) {
  const encoded = encodeURIComponent(phone);
  const { data } = await api.get(
    `${RESTFUL.whatsappMessage.byPhone}/${encoded}`,
    { params },
  );
  return data;
}
